/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_CatInputs */

const en_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const ar_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const bn_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const de_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const es_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const fr_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const pt_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const zh_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const tr_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const ru_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

const pl_svc_mvp_sprint_cat = /** @type {(inputs: Svc_Mvp_Sprint_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MVP`)
};

/**
* | output |
* | --- |
* | "#MVP" |
*
* @param {Svc_Mvp_Sprint_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_cat = /** @type {((inputs?: Svc_Mvp_Sprint_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_cat(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_cat(inputs)
	if (locale === "de") return de_svc_mvp_sprint_cat(inputs)
	if (locale === "es") return es_svc_mvp_sprint_cat(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_cat(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_cat(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_cat(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_cat(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_cat(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_cat(inputs)
	return en_svc_mvp_sprint_cat(inputs)
});
export { svc_mvp_sprint_cat as "svc_mvp-sprint_cat" }